export const CHANNEL_OPTIONS = {
  title: 'Channel',
  key: 'channels',
  type: 'checkbox',
  multiple: true,
  options: [
    { label: 'AVO Store', value: 'avostore' },
    { label: 'General Trade', value: 'general_trade' },
    { label: 'Modern Trade', value: 'modern_trade' },
    { label: 'Distributor', value: 'distributor' },
  ],
}